import { Switch } from "@headlessui/react"
import Translation from "components/Translation"
import { classNames } from "utils/dom-helpers"

type GenericSwitchProps = {
    is_on: boolean
    toggleOn: (on: boolean) => void
    switch_class_names?: string
    switch_size?: string
    switch_border_style?: string
    switch_on_style?: string
    switch_off_style?: string
    toggle_class_names?: string
    toggle_size?: string
    toggle_on_style?: string
    toggle_off_style?: string
    label?: string,
    label_contents?: Record<string, string>
    disabled?: boolean
    switch_disabled_style?: string
}

export default function GenericSwitch(
    {
        is_on,
        toggleOn,
        switch_class_names = `block relative inline-flex flex-shrink-0
        rounded-full cursor-pointer
        transition-colors ease-in-out duration-200 focus:outline-none
        focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 my-auto mr-3`,
        switch_size = "h-5 w-10",
        switch_border_style = "border-2 border-transparent",
        switch_on_style = 'bg-custom-dark-cyan-blue',
        switch_off_style = 'bg-gray-300',
        toggle_class_names = `pointer-events-none inline-block rounded-full 
        bg-white shadow-lg transform ring-0 transition ease-in-out duration-300`,
        toggle_size = "h-4 w-4",
        toggle_on_style = "translate-x-5",
        toggle_off_style = "translate-x-0",
        label,
        label_contents,
        disabled,
        switch_disabled_style
    }: GenericSwitchProps
) { //TODO: refactor all the other switches to use this one
    return (
        <>
            <div className="flex items-center gap-3">
            <Switch
                checked={is_on}
                disabled={disabled}
                onChange={() =>
                    toggleOn(!is_on)
                }
                className={classNames(
                    switch_size,
                    switch_border_style,
                    switch_class_names,
                    disabled && switch_disabled_style ? switch_disabled_style : "",
                    is_on
                        ? switch_on_style
                        : switch_off_style,
                )}
            >
                <span
                    aria-hidden="true"
                    className={classNames(
                        toggle_size,
                        toggle_class_names,
                        is_on
                            ? toggle_on_style
                            : toggle_off_style,
                        
                    )}
                />
            </Switch>
            <label className="label-font">
            {label &&
                <Translation 
                    content_key={label}
                    content_values={label_contents}
                />
            }
            </label>
            </div>
        </>
    )
}